import AuthLayout from '../../../components/shared/AuthLayout';
import SignUpForm from '../../../components/auth/SignUpForm';
import { Link } from '@mui/material';

const SignUpPage = () => {
  const sideImageUrl = "https://images.unsplash.com/photo-1579546929662-711aa81148cf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80";

  return (
    <AuthLayout
      sideImageUrl={sideImageUrl}
      FormComponent={SignUpForm}
      pageTitle="Join Our Community"
      pageDescription="Create your account to find the perfect roommate match"
      sideTitle="Find Your Perfect Match"
      sideSubtitle="Join thousands of successful roommate connections. Your ideal living companion awaits."
      additionalLink={
        <>Already have an account? <Link href="/fmr/sign-in" sx={{ color: '#00ff88', fontWeight: 600, '&:hover': { textDecoration: 'underline' } }}>Sign in</Link></>
      }
    />
  );
};

export default SignUpPage;